// Intercept fetch + XHR early to capture customer ID from any JSON response
// containing a Shopify customer GID (Skio's StorefrontUserByPk query).
(function () {
  if (window._shopifyCidInterceptor) return;
  window._shopifyCidInterceptor = true;

  function extractCid(text) {
    if (!text || window.shopifyCustomerId) return;
    // Match gid://shopify/Customer/ID — handles both / and escaped \/
    var m = text.match(/shopify[\\\/]+Customer[\\\/]+(\d{8,})/);
    if (m) {
      window.shopifyCustomerId = m[1];
      document.dispatchEvent(new CustomEvent('shopify:customer-id', { detail: { id: m[1] } }));
    }
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    return origFetch.apply(this, args).then(function (res) {
      if (window.shopifyCustomerId) return res;
      try { res.clone().text().then(extractCid).catch(function () {}); } catch (e) {}
      return res;
    });
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function () {
    this._url = arguments[1] || '';
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    xhr.addEventListener('load', function () {
      if (window.shopifyCustomerId) return;
      try { extractCid(xhr.responseText); } catch (e) {}
    });
    return origSend.apply(this, arguments);
  };
}());

document.addEventListener('DOMContentLoaded', function () {
  var picker = document.querySelector('.tshirt-size-picker');
  if (!picker) return;

  var card          = picker.closest('.tshirt-size-picker-card');
  var proxyUrl      = picker.dataset.proxyUrl;
  var proxyGetUrl   = picker.dataset.proxyGetUrl;
  var statusEl      = picker.querySelector('.tshirt-size-picker__status');
  var currentEl     = picker.querySelector('.tshirt-size-picker__current-value');

  var LS_SIZE    = 'mem_tshirt_size';
  var statusTimer;

  picker.querySelectorAll('.tshirt-size-picker__option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectSize(btn, btn.dataset.size);
      saveSize(btn.dataset.size);
    });
  });

  // Fire initial load; may 401 if Skio hasn't responded yet.
  // The inline interceptor dispatches shopify:customer-id once it captures the GID —
  // retry then so the correct size loads without requiring a page refresh.
  loadSize();
  document.addEventListener('shopify:customer-id', function () { loadSize(); }, { once: true });

  function buildParams(extra) {
    var params = {};
    if (window.shopifyCustomerId) params.customerId = window.shopifyCustomerId;
    if (extra) Object.keys(extra).forEach(function (k) { params[k] = extra[k]; });
    return params;
  }

  function loadSize() {
    if (!proxyGetUrl) { fallbackLoad(); return; }

    var p = buildParams();
    var qs = Object.keys(p).map(function (k) { return k + '=' + encodeURIComponent(p[k]); }).join('&');
    var url = proxyGetUrl + (qs ? '?' + qs : '');

    fetch(url, { method: 'GET', credentials: 'include', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (response.status === 401 || response.status === 403) { fallbackLoad(); return null; }
        if (!response.ok) throw new Error('load_failed');
        if (card) card.style.display = '';
        return response.json();
      })
      .then(function (data) {
        if (!data) return;
        var size = data.size;
        if (size) { activate(size); localStorage.setItem(LS_SIZE, size); return; }
        fallbackLoad();
      })
      .catch(fallbackLoad);
  }

  function fallbackLoad() {
    var v = localStorage.getItem(LS_SIZE);
    if (v) activate(v);
  }

  function saveSize(size) {
    localStorage.setItem(LS_SIZE, size);
    if (!proxyUrl) { showStatus('Saved on this device only.', true); return; }

    var body = buildParams({ size: size });
    fetch(proxyUrl, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        if (response.ok) { showStatus('Saved!', false); return; }
        if (response.status === 401 || response.status === 403) {
          showStatus('Saved on this device. Open via Shopify account login to sync.', true);
          return;
        }
        throw new Error('save_failed');
      })
      .catch(function () {
        showStatus('Could not sync right now. Saved on this device.', true);
      });
  }

  function activate(size) {
    var btn = picker.querySelector('[data-size="' + size + '"]');
    if (btn) selectSize(btn, size);
  }

  function selectSize(btn, size) {
    picker.querySelectorAll('.tshirt-size-picker__option').forEach(function (b) {
      b.classList.remove('is-selected');
      b.setAttribute('aria-pressed', 'false');
      b.style.borderColor = 'rgba(0,0,0,0.2)';
      b.style.background = 'transparent';
      b.style.color = '#333';
    });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');
    btn.style.borderColor = '#111';
    btn.style.background = '#111';
    btn.style.color = '#fff';
    if (currentEl) currentEl.textContent = size.toUpperCase();
  }

  function showStatus(msg, isError) {
    statusEl.textContent = msg;
    statusEl.hidden = false;
    statusEl.classList.toggle('is-error', isError);
    clearTimeout(statusTimer);
    statusTimer = setTimeout(function () { statusEl.hidden = true; }, isError ? 5000 : 3000);
  }
});
